import { Link } from "react-router-dom";
import { Star, Quote } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS, IMAGES } from "@/lib/content";

export default function Testimonials() {
  return (
    <div data-testid="testimonials-page">
      <PageHeader
        overline="Parent experiences"
        title="Real families,"
        italic="real progress."
        subtitle="Nothing means more than a parent watching their child become safer and more confident in the water."
      />

      <section className="py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} delay={(i % 3) * 0.1}>
              <div className="break-inside-avoid p-8 rounded-2xl bg-white border" style={{ borderColor: "rgba(212,175,55,0.25)" }}>
                <Quote size={30} style={{ color: "var(--gold)" }} />
                <div className="flex gap-1 my-4">
                  {[...Array(5)].map((_, s) => <Star key={s} size={16} fill="var(--gold)" style={{ color: "var(--gold)" }} />)}
                </div>
                <p className="font-accent italic text-lg leading-relaxed" style={{ color: "var(--navy)" }}>"{t.quote}"</p>
                <div className="mt-6 pt-6 border-t" style={{ borderColor: "rgba(212,175,55,0.2)" }}>
                  <p className="overline" style={{ color: "var(--gold)" }}>{t.label}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-xl mx-auto px-6">
          <Reveal>
            <div className="rounded-3xl overflow-hidden border shadow-[0_20px_60px_rgba(11,27,61,0.15)]" style={{ borderColor: "rgba(212,175,55,0.4)" }}>
              <img src={IMAGES.supportQuote} alt="Support isn't a transaction — refer people because they do a great job" className="w-full h-auto block" />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-20" style={{ backgroundColor: "var(--sand)" }}>
        <div className="max-w-2xl mx-auto px-6 text-center">
          <Reveal>
            <h2 className="font-display text-3xl md:text-5xl" style={{ color: "var(--navy)" }}>Ready to write your own story?</h2>
            <Link to="/contact" className="btn-primary mt-8">Request Availability</Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
